module.exports = __webpack_public_path__ + "img/THECB-logo-primary.ce23a0e7.svg";